import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Building2, School, BookOpen, ClipboardList, Newspaper, ArrowRight, TrendingUp } from 'lucide-react';
import { adminStats } from '../lib/api';

const CARDS = [
  { key: 'colleges', label: 'Colleges', icon: Building2, color: 'bg-teal-500' },
  { key: 'universities', label: 'Universities', icon: School, color: 'bg-orange-500' },
  { key: 'courses', label: 'Courses', icon: BookOpen, color: 'bg-indigo-500' },
  { key: 'exams', label: 'Exams', icon: ClipboardList, color: 'bg-rose-500' },
  { key: 'blogs', label: 'Blogs', icon: Newspaper, color: 'bg-emerald-500' },
];

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminStats().then(setStats).catch(() => setStats({}));
  }, []);

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Dashboard</h1>
        <p className="text-slate-500 text-sm mt-1">Overview of your platform content.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {CARDS.map((c) => (
          <Link key={c.key} to={`/admin/${c.key}`} className="group bg-white rounded-2xl border border-slate-200 p-5 card-lift">
            <div className={`w-11 h-11 rounded-xl ${c.color} grid place-items-center text-white shadow-sm`}>
              <c.icon className="w-5 h-5" />
            </div>
            <div className="mt-4 text-3xl font-bold text-slate-900" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              {stats ? (stats[c.key] ?? 0) : ' - '}
            </div>
            <div className="text-sm text-slate-600 mt-0.5">Total {c.label}</div>
            <div className="mt-3 pt-3 border-t border-slate-100 flex items-center justify-between text-xs">
              <span className="text-slate-500">Manage</span>
              <ArrowRight className="w-3.5 h-3.5 text-teal-600 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-8 bg-white rounded-2xl border border-slate-200 p-6">
        <h2 className="font-semibold text-slate-900 mb-3" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Quick Tips</h2>
        <ul className="space-y-2 text-sm text-slate-700">
          <li className="flex gap-2"><TrendingUp className="w-4 h-4 text-teal-600 mt-0.5" /> Use image URLs from Unsplash / Pexels for college banners.</li>
          <li className="flex gap-2"><TrendingUp className="w-4 h-4 text-teal-600 mt-0.5" /> Rankings drive homepage &amp; listing order  -  lower number = higher rank.</li>
          <li className="flex gap-2"><TrendingUp className="w-4 h-4 text-teal-600 mt-0.5" /> Keep the "short" name concise; it&apos;s used in cards.</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminDashboard;
